import VueRouter from "vue-router";

const routes = [
  {
    path: "/",
    name: "/",
    component: () => import("../views/store-index/index")
  },
  {
    path: "/login-success",
    component: () => import("../views/login-success"),
  },
  {
    name: "home",
    path: "/home",
    component: () => import("../views/home"),
  },
  {
    name: "public",
    path: "/public",
    component: () => import("../views/public"),
  },
  {
    name: "bind-card",
    path: "/bind-card",
    component: () => import("../views/bind-card"),
    meta: { title: "激活卡券" },
  },
  {
    path: "/hw-h5",
    component: () => import("../views/hw-h5.vue"),
  },
  {
    path: "/hw-h5-2",
    component: () => import("../views/hw-h5-2.vue"), // 这里得加 .vue 后缀, 我猜是因为有同名不同后缀的文件
  },
  {
    path: "/icon",
    component: () => import("../views/icon"),
  },
  {
    path: "/hw-h5-order-pay",
    component: () => import("../views/hw-h5-order-pay"),
  },
  {
    path: "/JDJL-order-pay",
    component: () => import("../views/JDJL-order-pay"),
  },
  {
    path: "/YHCS-order-pay",
    component: () => import("../views/YHCS-order-pay"),
  },
  {
    path: "/WDG-order-pay",
    component: () => import("../views/WDG-order-pay"),
  },
  {
    name: "bind-mobile",
    path: "/bind-mobile",
    component: () => import("../views/bind-mobile"),
    meta: { title: "新用户绑定手机" },
  },
  {
    name: "card-mobile-bind",
    path: "/card-mobile-bind",
    component: () => import("../views/user-center/card-mobile-bind"),
    meta: { title: "绑定手机 领卡" },
  },
  {
    name: "store-index",
    path: "/store-index",
    component: () => import("../views/store-index/index"),
    meta: { title: "生活商城" },
  },
  {
    name: "user",
    path: "/user",
    component: () => import("../views/user"),
    meta: { title: "用户中心 ε" },
  },
  {
    name: "user-cards",
    path: "/user-cards",
    component: () => import("../views/user-cards"),
    meta: { title: "我的卡券" },
  },
  {
    name: "card-detail",
    path: "/card-detail",
    component: () => import("../views/user-center/card-detail"),
    meta: { title: "付款码" },
  },
  {
    name: "goods-list",
    path: "/goods-list",
    component: () => import("../views/goods-list/index"),
    meta: { title: "商品列表" },
  },
  {
    name: "goods-list-ecoupo",
    path: "/goods-list-ecoupo",
    component: () => import("../views/goods-list-ecoupo/index"),
    meta: { title: "电子券" },
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("../views/cart/index"),
    meta: { title: "购物车" },
  },
  {
    name: "goods-cate-list",
    path: "/goods-cate-list",
    component: () => import("../views/goods-cate-list/index"),
    meta: { title: "分类" },
  },
  {
    name: "goods-detail",
    path: "/goods-detail",
    component: () => import("../views/goods-detail/index"),
    meta: { title: "详情" },
  },
  {
    name: "ticket-list",
    path: "/ticket-list",
    component: () => import("../views/ticket-list/index"),
    meta: { title: "门票列表" },
  },
  {
    name: "ticket-detail",
    path: "/ticket-detail",
    component: () => import("../views/ticket-detail/index"),
    meta: { title: "门票详情" },
  },
  {
    name: "enter-order",
    path: "/enter-order",
    component: () => import("../views/enter-order/index"),
    meta: { title: "确认订单" },
  },
  {
    name: "base-question",
    path: "/base-question",
    component: () => import("../views/base-question/index"),
    meta: { title: "常见问题" },
  },
  {
    name: "coupon-detail",
    path: "/coupon-detail",
    component: () => import("../views/coupon-detail/index"),
    meta: { title: "卡券详情" },
  },
  {
    name: "topic-detail",
    path: "/topic-detail",
    component: () => import("../views/topic-detail/index"),
    meta: { title: "专题商品" },
  },
  {
    name: "seckill-detail",
    path: "/seckill-detail",
    component: () => import("../views/seckill-detail/redirect-act-index"),
  },
  {
    name: "seckill-index",
    path: "/seckill-index",
    component: () => import("../views/seckill-detail/index"),
    meta: { title: "多选 ㄇ" },
  },
  {
    name: "seckill-public",
    path: "/seckill-public",
    component: () => import("../views/seckill-detail/public"),
    meta: { title: "多选 ㄈ" },
  },
  {
    name: "seckill-goods-detail",
    path: "/seckill-goods-detail",
    component: () => import("../views/seckill-detail/detail"),
    meta: { title: "多选 ㄩ" },
  },
  {
    name: "brand-detail",
    path: "/brand-detail",
    component: () => import("../views/brand-detail/index"),
    meta: { title: "品牌商品" },
  },
  {
    name: "birthday",
    path: "/birthday",
    component: () => import("../views/birthday/index"),
    meta: { title: "生日汇" },
  },
  {
    name: "index",
    path: "/index",
    component: () => import("../views/store-index/index"),
    meta: { title: "首页 商城" },
  },
  {
    name: "index-new",
    path: "/index-new",
    component: () => import("../views/store-index-new/index"),
    meta: { title: "首页 •̀ω•́" },
  },
  {
    name: "index-v3",
    path: "/index-v3",
    component: () => import("../views/store-index-v3/index"),
    meta: { title: "首页 ó_ò", keepAlive: true },
  },
  {
    name: "movie",
    path: "/movie",
    component: () => import("../views/movie"),
    meta: { title: "电影" },
  },
  {
    name: "common-index",
    path: "/common-index",
    component: () => import("../views/module-common-index"),
    meta: { title: "首页 'ㅅ'" },
  },
  {
    name: "select-card-pay",
    path: "/select-card-pay",
    component: () => import("../views/user-center/select-card-pay/index"),
    meta: { title: "卡券支付" },
  },
  {
    name: "user-center-index",
    path: "/user-center-index",
    component: () => import("../views/user-center/index/index"),
    meta: { title: "用户中心 ζ" },
  },
  {
    name: "user-center-help",
    path: "/user-center-help",
    component: () => import("../views/user-center/help/help"),
    meta: { title: "常见问题" },
  },
  {
    name: "user-center-address",
    path: "/user-center-address",
    component: () => import("../views/user-center/address/address"),
    meta: { title: "地址管理" },
  },
  {
    name: "user-center-address-edit",
    path: "/user-center-address-edit",
    component: () => import("../views/user-center/address/address-edit"),
    meta: { title: "地址编辑" },
  },
  {
    name: "user-center-info",
    path: "/user-center-info",
    component: () => import("../views/user-center/info/info"),
    meta: { title: "信息管理" },
  },
  {
    name: "user-center-info-edit",
    path: "/user-center-info-edit",
    component: () => import("../views/user-center/info/info-edit"),
    meta: { title: "信息编辑" },
  },
  {
    name: "user-center-common",
    path: "/user-center-common",
    component: () => import("../views/user-center/common"),
  },
  {
    name: "user-center-update-pwd",
    path: "/user-center-update-pwd",
    component: () => import("../views/user-center/update-pwd/update-pwd"),
    meta: { title: "支付密码修改" },
  },
  {
    name: "user-center-order-submit",
    path: "/user-center-order-submit",
    component: () => import("../views/user-center/order-submit/index"),
    meta: { title: "确认订单" },
  },
  {
    name: "user-center-order-submit-detail",
    path: "/user-center-order-submit-detail",
    component: () => import("../views/user-center/order-submit/detail"),
    meta: { title: "订单详情" },
  },

  {
    name: "user-center-order-list-goods",
    path: "/user-center-order-list-goods",
    component: () => import("../views/user-center/order-list/goods/order-list"),
    meta: { title: "订单列表" },
  },
  {
    path: "/movie-order-list",
    redirect: { path: "/order-list", query: { orderType: "movie" } },
    meta: { title: "电影订单" },
  },
  {
    path: "/q-ticket-order-list",
    redirect: { path: "/order-list", query: { orderType: "ticket" } },
    meta: { title: "电子券订单" },
  },
  {
    name: "ticket-order-list",
    path: "/ticket-order-list",
    component: () => import("../views/user-center/order-list/ticket/ticket-order-list"),
    meta: { title: "电子券订单" },
  },
  {
    name: "movie-order-create",
    path: "/movie-order-create", // @see v6/movie-order-create
    component: () => import("../views/user-center/order-list/movie/movie-order-create"),
    meta: { title: "创建电影订单" },
  },
  {
    name: "order-pay",
    path: "/order-pay",
    component: () => import("../views/user-center/order-pay"),
    meta: { title: "订单支付" },
  },
  {
    name: "cate-index",
    path: "/cate-index",
    component: () => import("../views/cate-index"),
    meta: { title: "cate-index" },
  },
  {
    name: "topic-list",
    path: "/topic-list",
    component: () => import("../views/topic-list"),
    meta: { title: "专题商品" },
  },
  {
    name: "express-info",
    path: "/express-info",
    component: () =>
      import("../views/user-center/order-list/goods/express-info"),
    meta: { title: "快递信息" },
  },
  {
    name: "order-list",
    path: "/order-list",
    component: () => import("../views/order-list"),
    meta: { title: "订单列表" },
  },
  {
    name: "bind-card-success",
    path: "/bind-card-success",
    component: () => import("../views/user-center/bind-card-success"),
    meta: { title: "领取成功" },
  },
  {
    name: "act-list-cxyq",
    path: "/act-list-cxyq",
    component: () => import("../views/act-list/cxyq2023"),
    meta: { title: "川西北气矿工会职工幸福影院" },
  },
  {
    path: "/act-list-cxyq2023-detail",
    redirect: { path: "/topic-detail", query: { topicId: 16, buyFlag: 1 } },
    meta: { title: "川西北气矿工会职工幸福影院" },
  },
  {
    name: "act-list-ghdy",
    path: "/act-list-ghdy",
    component: () => import("../views/act-list/ghdy"),
    meta: { title: "观影活动" },
  },
  {
    name: "act-list-ghdy2",
    path: "/act-list-ghdy2",
    component: () => import("../views/act-list/ghdy2"),
    meta: { title: "工会电影活动" },
  },
  {
    name: "act-list-ghdy3",
    path: "/act-list-ghdy3",
    component: () => import("../views/act-list/ghdy3"),
    meta: { title: "工会电影活动" },
  },
  {
    name: "act-list-hhyf-duanwu",
    path: "/act-list-hhyf-duanwu",
    component: () => import("../views/act-list/hhyf-duanwu"),
    meta: { title: "宏华油服" },
  },
  {
    name: "act-index",
    path: "/act-index",
    component: () => import("../views/act-list/index")
  },
  {
    name: "health-index",
    path: "/health-index",
    component: () => import("../views/health/index"),
    meta: { title: "首页 (︶^︶)" },
  },
  {
    name: "health-detail",
    path: "/health-detail",
    component: () => import("../views/health/detail"),
    meta: { title: "" },
  },
  {
    name: "health-list",
    path: "/health-list",
    component: () => import("../views/health/list"),
    meta: { title: "体检预约" },
  },
  {
    name: "travel-index",
    path: "/travel-index",
    component: () => import("../views/travel/index"),
    meta: { title: "门票首页" },
  },
  {
    name: "travel-detail",
    path: "/travel-detail",
    component: () => import("../views/travel/detail")
  },
  {
    name: "travel-order",
    path: "/travel-order",
    component: () => import("../views/travel/order")
  },
  {
    name: "module-list",
    path: "/module-list",
    component: () => import("../views/module-list.vue")
  },
  {
    path: "*",
    component: () => import("../views/404.vue")
  }
];

export const router = new VueRouter({
  mode: "history",
  base: "/web",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.y) {
      return { x: 0, y: to.meta.y };
    }

    if (savedPosition) {
      return savedPosition;
    }

    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
  },
});
